// LA: the customer's linked accounts (customer + MBP branch + TAS code rows), shared by the Customers
// list's "View MBP Branch Accounts" dialog and the customer's Linked Accounts tab (which had no list).
// Remove now asks first.
import CustomerService from "@/service/CustomerService";

export default {
  data: () => ({
    customerService: new CustomerService(),
    requesting: false,
    linkedAccounts: [],
    accountDialog: false,
    realodAccountDialog: 0,
    refreshAccountDialog: 0,
    account: {},
    disabledArr: [],
    removingLink: {},
    activeButtonClicked: false,
    removeCandidate: null,
    displayRemoveConfirm: false
  }),
  methods: {
    // LA: Remove asks "Remove the link to <branch>?" first; a main branch is refused straight away
    askRemoveLink(account) {
      if (account && account.mainBranch) {
        this.removeLink(account);
        return;
      }
      this.removeCandidate = account;
      this.displayRemoveConfirm = true;
    },
    confirmRemoveLink() {
      const account = this.removeCandidate;
      this.displayRemoveConfirm = false;
      this.removeCandidate = null;
      if (account) this.removeLink(account);
    },

    removeLink(account) {
      if (!account.mainBranch) {
        if (account.customerId && account.branchId) {
          this.removingLink = account;

          this.customerService
            .removeLink(account.customerId, account.branchId)
            .then(data => {
              this.removingLink = {};
              this.$toast.add({
                severity: "success",
                summary: "Link removed",
                detail: `${account.branchName || account.branchCode || "The branch"} is no longer linked.`,
                life: 5000
              });
              this.assignedCustomerMBPbranches();
            })
            .catch(error => {
              this.removingLink = {};
              let index = -1,
                a = "java.lang.RuntimeException: ";
              if (error.response.data) {
                index = error.response.data.indexOf(a);
              }
              if (index < 0) {
                this.$store.dispatch("addErrorMessage", {
                  severity: "error",
                  content:
                    'Some data was not loaded from "unlinkBranch/{customerId}{branchId}"'
                });
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error Message",
                  detail: error.response.data.substr(
                    index + a.length,
                    error.response.data.length - 1
                  ),
                  life: 5000
                });
              }
            });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Data representation undefined!",
            life: 5000
          });
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            "You can't remove a main Branch. Set a different main Branch first.",
          life: 5000
        });
      }
    },

    reverseAcountActive() {
      let index = this.linkedAccounts.findIndex(
        a => a.branchCode === this.account.branchCode
      );
      if (!this.linkedAccounts[index].mainBranch && this.activeButtonClicked) {
        this.linkedAccounts[index].active = !this.linkedAccounts[index].active;
      }
      //
    },

    closeAccountForm() {
      this.accountDialog = false;
      // this.reverseAcountActive()
    },

    savedAccount(account) {
      this.assignedCustomerMBPbranches();
      this.accountDialog = false;
    },

    accountClicked(account) {
      if (account.data) {
        this.activeButtonClicked = false;
        this.account = account.data;
      } else {
        this.activeButtonClicked = true;
        this.account = account;
      }

      if (this.account) {
        if (this.account.mainBranch) {
          this.disabledArr = ["mbpBranch", "mainBranch", "active"];
        } else {
          this.disabledArr = ["mbpBranch"];
        }
        this.accountDialog = true;
        this.refreshAccountDialog++;
        this.realodAccountDialog++;
      }
    },

    assignedCustomerMBPbranches() {
      if (this.customer && this.customer.customerId) {
        this.requesting = true;
        this.linkedAccounts = [];

        this.customerService
          .assignedCustomerMBPbranches(this.customer.customerId)
          .then(data => {
            this.requesting = false;

            this.linkedAccounts = data;
          })
          .catch(error => {
            this.requesting = false;

            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "assignedCustomerMBPbranches/{customerId}"'
            });
          });
      }
    }
  }
};
